import React from 'react';
import { BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const LedgerAccessLink = ({ testId, children = 'Open Ledger', className = '' }) => (
  <Button asChild size="sm" variant="outline" className={`h-8 gap-1.5 ${className}`}>
    <Link to="/admin/finance?tab=ledger" data-testid={testId}>
      <BookOpen className="h-3.5 w-3.5" />
      {children}
    </Link>
  </Button>
);